import React, { useState, useEffect } from 'react';
import { Heart, X, Coffee } from 'lucide-react';
import { HOME } from '@/constants/testIds';

const PAYPAL_URL = 'https://www.paypal.com/donate/?hosted_button_id=LPC97GTZDJJSU';

/**
 * FloatingDonate — appears after the listener has been on the page ~25 s.
 * Timing matters: trigger after the user has experienced value (music + PWA section),
 * not immediately. Dismissible. localStorage-aware so we don't nag the same session.
 */
const FloatingDonate = () => {
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && sessionStorage.getItem('mjr_donate_dismissed') === '1') {
      setDismissed(true);
      return;
    }
    const t = setTimeout(() => setVisible(true), 25000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem('mjr_donate_dismissed', '1'); } catch {}
  };

  if (dismissed || !visible) return null;

  return (
    <div className="fixed bottom-5 left-5 z-40 max-w-[18rem] animate-fade-up">
      <div className="relative rounded-2xl border border-amber/40 bg-vinyl/95 backdrop-blur-xl p-4 shadow-[0_20px_50px_-10px_rgba(0,0,0,0.7)] donate-glow">
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-espresso border border-amber/30 flex items-center justify-center text-cream/70 hover:text-amber"
        >
          <X className="w-3.5 h-3.5" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 shrink-0 rounded-full bg-amber/15 flex items-center justify-center">
            <Heart className="w-5 h-5 text-amber" fill="currentColor" />
          </div>
          <div className="flex-1">
            <div className="font-display text-base text-cream leading-tight">
              Glad to have you with us.
            </div>
            <div className="text-xs text-cream/60 font-body mt-1 leading-relaxed">
              If the music keeps you company, a small gesture helps keep it on the air.
            </div>
            <a
              data-testid={HOME.paypalCtaFloating}
              href={PAYPAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center justify-center w-full gap-2 px-3 py-2 rounded-full bg-[#FFC439] text-vinyl font-body font-bold text-xs uppercase tracking-wider hover:scale-[1.02] transition"
            >
              <Heart className="w-3.5 h-3.5" fill="currentColor" /> Support the station · PayPal
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingDonate;
